
import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { RotateCcw } from 'lucide-react';
import { PromptChat, ChatMessageData } from './PromptChat';
import { ToolComparisonChallenge } from './ToolComparisonChallenge';
import { UseCaseIdentificationChallenge } from './UseCaseIdentificationChallenge';

interface PracticeTabsProps {
  chatMessages: ChatMessageData[];
  setChatMessages: React.Dispatch<React.SetStateAction<ChatMessageData[]>>;
  userInitials: string;
  handleNewChallenge: () => void;
  isLoading: boolean;
  activeDailyChallenge: number;
}

export const PracticeTabs = ({ 
  chatMessages, 
  setChatMessages, 
  userInitials, 
  handleNewChallenge,
  isLoading,
  activeDailyChallenge
}: PracticeTabsProps) => {
  // Get challenge title based on ID
  const getChallengeTitle = (challengeId: number) => {
    switch (challengeId) {
      case 1: return "Prompt Practice";
      case 2: return "AI Tool Comparison";
      case 3: return "Scenarios";
      default: return "Practice";
    }
  };

  return (
    <div className="w-full flex flex-col flex-grow">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium">{getChallengeTitle(activeDailyChallenge)}</h3>
        <Button 
          variant="outline" 
          size="sm" 
          className="ml-2 flex-shrink-0"
          onClick={handleNewChallenge}
          disabled={isLoading}
        >
          <RotateCcw className="h-4 w-4 mr-1" />
          New Challenge
        </Button>
      </div>

      <div className="flex-grow flex flex-col">
        {activeDailyChallenge === 1 && (
          <PromptChat 
            chatMessages={chatMessages}
            setChatMessages={setChatMessages}
            userInitials={userInitials}
            isChildComponent={true}
          />
        )}
        
        {activeDailyChallenge === 2 && (
          <ToolComparisonChallenge 
            userInitials={userInitials} 
            isChildComponent={true}
          />
        )}
        
        {activeDailyChallenge === 3 && (
          <UseCaseIdentificationChallenge 
            userInitials={userInitials} 
            isChildComponent={true}
          />
        )}
      </div>
    </div>
  );
};
